import React from "react";
import Sidebar from "@components/Sidebar.tsx";
import Navbar from "./Navbar.tsx";
import { Outlet } from "react-router-dom";
import { MenuProvider } from "@components/MenuContext.tsx"; // tokony reglage an'le titre importation
import MobileHeader from "./HeaderMobile.tsx";
import MenuMobile from "./MenuMobile.tsx";
const MainLayout: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  return (
    <MenuProvider>
      <div className="hidden md:flex">
        <Sidebar />

        <div className="flex-1 ml-72 contenu">
          <Navbar />

          <main className="main">
            <Outlet />
          </main>
        </div>
      </div>

      <div className="md:hidden flex">
        <MobileHeader isMenuOpen={isMenuOpen} onMenuToggle={() => setIsMenuOpen(prev => !prev)} />
        <MenuMobile isMobileMenuOpen={isMenuOpen} closeMobileMenu={() => setIsMenuOpen(false)} />
        <main className="main w-full pt-24">
          <Outlet />
        </main>
      </div>
    </MenuProvider>
  );
};

export default MainLayout;
